




























































import {Component} from "vue-property-decorator";
import {LocationStore} from "@/modules/location/store";
import {LocationParams} from "@/modules/location/params";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import LocationSearch from "@/modules/location/List/components/Search.vue";
import {deleteLocations} from "@/modules/location/services";

@Component({
    name: "LocationList",
    components: {LocationSearch, TooltipLabel}
})
export default class extends mixins(CommonMixin) {
    selectedIds: any = [];
    columns = [
        {
            title: "Thao tác",
            dataIndex: "id",
            key: "id",
            scopedSlots: {customRender: 'action'},
            width: 30
        },
        // {
        //     title: "SĐT Người nhận",
        //     dataIndex: "phoneNumber",
        //     key: "phoneNumber",
        //     width: 100,
        //     ellipsis: true,
        //     scopedSlots: {customRender: "phoneNumber"}
        // },
        {
            title: "Người nhận",
            dataIndex: "name",
            key: "name",
            width: 100,
            ellipsis: true,
            scopedSlots: {customRender: "name"}
        },
        {
            title: "Địa chỉ",
            dataIndex: "address",
            key: "address",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "address"}
        },
        // {
        //     title: "Nơi đến",
        //     dataIndex: "province.name",
        //     key: "province",
        //     width: 100,
        //     ellipsis: true,
        //     scopedSlots: {customRender: "province"}
        // },
        // {
        //     title: "Quận/Huyện",
        //     dataIndex: "district",
        //     key: "district",
        //     width: 100,
        //     ellipsis: true,
        //     scopedSlots: {customRender: "district"}
        //
        // },
        // {
        //     title: "Phường/Xã",
        //     dataIndex: "ward",
        //     key: "ward",
        //     width: 100,
        //     ellipsis: true,
        //     scopedSlots: {customRender: "ward"}
        // }
    ];

    created() {
        LocationStore.updateLocationParams(new LocationParams());
        LocationStore.listLocation(LocationStore.params)
        console.log(LocationStore.data)
    }

    get locations() {
        return LocationStore.locations;
    }

    get pagination() {
        return {
            current: LocationStore.meta.page,
            pageSize: LocationStore.meta.limit,
            total: LocationStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} địa chỉ`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        LocationStore.listLocation({
            ...LocationStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
    }

    async onConfirm(id: any) {
        // try {
        //     await LocationStore.deleteLocation(id);
        //     this.$message.success("Xóa địa chỉ thành công");
        // } catch (e) {
        //     this.$message.error(e?.response?.data?.message || "Xóa địa chỉ thất bại");
        // }
      // this.selectedIds.push(id);
      const i = this.selectedIds.indexOf(id);
      if (i === -1) {
        this.selectedIds.push(id);   // thêm
      } else {
        this.selectedIds.splice(i, 1); // bỏ
      }
    }

    onConfirmCreateLading(location) {
        LocationStore.updateLocationCreateLading(location)
        this.$router.push({name: "createLading"});
    }

    get rowSelection() {
        return {selectedRowKeys: this.selectedIds, onChange: this.onSelectChange};
    }

    onSelectChange(selectedRowKeys: any) {
        this.selectedIds = selectedRowKeys;
    }
    async deleteLocations() {
        try {
            await deleteLocations({ids: this.selectedIds})
            await LocationStore.listLocation()
            this.$message.success("Xóa địa chỉ thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa địa chỉ thất bại");
        }
    }
}
